import { Component, OnInit } from '@angular/core';
import { AppService } from '../../app.service';
import { isArrayWithData } from '../../utilities/array.helpers';
import { catchError, finalize, tap } from 'rxjs';
import moment from 'moment';
import { QfundTransactionsService } from '../../services/qfund-transactions/qfund-transactions.service';

@Component({
    selector: 'app-qfund-posts-report',
    templateUrl: './qfund-posts-report.component.html',
    styleUrl: './qfund-posts-report.component.css',
})
export class QfundPostsReportComponent implements OnInit {
    reportData: any = [];

    isReportPendingRetrieval: boolean = false;
    fromDate?: Date;
    toDate?: Date;

    selectedCreditorCompanyName: string = '';
    selectedCreditorId: string = '';
    hasClickedSearch: boolean = false;

    constructor(
        private appService: AppService,
        private qfundTransactionsService: QfundTransactionsService,
    ) {}

    public ngOnInit(): void {
        //this.mockData();
    }

    get hasTableData(): boolean {
        return isArrayWithData(this.reportData);
    }

    mockData = () => {
        this.reportData = [
            {
                transactionCorrelationId: '6767yo-6767ey-6767woah',
                invoiceNumber: 'creditor/105/accountinvoice/77678',
            },
        ];
    };

    hasValidInputs = () => {
        if (!this.fromDate || !this.toDate) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide a From Date and a To Date',
            );
            return false;
        }

        if (!this.selectedCreditorId) {
            this.appService.showCommonMessageDialog(
                'Invalid',
                'Please provide a creditor',
            );
            return false;
        }

        return true;
    };

    getReport = () => {
        if (!this.hasValidInputs) {
            return;
        }

        this.hasClickedSearch = true;

        this.appService.isShowPageSpinner = true;
        this.qfundTransactionsService
            .getQfundPostsReport(
                this.selectedCreditorId,
                this.fromDate!,
                this.toDate!,
            )
            .pipe(
                tap((res: any) => {
                    if (isArrayWithData(res?.items)) {
                        this.reportData = res.items;
                    }
                }),
                catchError(this.appService.handleError),
                finalize(() => {
                    this.appService.isShowPageSpinner = false;
                }),
            )
            .subscribe();
    };

    exportReport = () => {
        if (!this.hasValidInputs) {
            return;
        }

        this.qfundTransactionsService
            .downloadQfundPostsReport(
                this.selectedCreditorId,
                this.fromDate!,
                this.toDate!,
            )
            .subscribe(
                (blob) => {
                    if (blob != null) {
                        const downloadUrl = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');

                        a.href = downloadUrl;
                        a.download = `HttpGatewayRequests_${this.selectedCreditorCompanyName}_${moment(this.fromDate).format('YYYY-MM-DD')}_to_${moment(this.toDate).format('YYYY-MM-DD')}.csv`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(downloadUrl);
                    }
                },
                (error) => {
                    console.error('Download failed', error);
                },
            );
    };

    onSelectCreditor(event: any) {
        this.hasClickedSearch = false;
        this.selectedCreditorId = event.CreditorId;
        this.selectedCreditorCompanyName = event.CompanyName;
    }
}
